module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": "flat"
    }
  }, [(_vm.withClientName) ? _c('v-toolbar', {
    staticClass: "subheading py-2",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("account_circle")]), _vm._v("\n    " + _vm._s(_vm.formatFullName(_vm.client)) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.withClientName) ? _c('v-divider') : _vm._e(), _vm._v(" "), (_vm.request.loading) ? _c('v-progress-linear', {
    staticClass: "mt-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.client && _vm.client.id) ? _c('v-list', [_c('v-subheader', {
    staticClass: "overline"
  }, [(!_vm.withClientName) ? _c('v-btn', {
    staticClass: "pl-0",
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1) : _vm._e(), _vm._v("\n      Contact information\n      "), _c('v-spacer'), _vm._v(" "), (_vm.relationshipId) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchCustomerDetailsDialog(_vm.relationshipId, true)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("phone")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.client.phone_number) ? _c('v-list-tile-title', [_vm._v(_vm._s(_vm.client.phone_number))]) : _c('v-list-tile-title', [_vm._v("No phone number")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Contact number")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.isRealEmail(_vm.client.email)) ? _c('v-list-tile-title', [_vm._v(_vm._s(_vm.client.email))]) : _c('v-list-tile-title', [_vm._v("No e-mail address")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("E-mail address")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.record && _vm.record.id) ? _c('v-list', {
    attrs: {
      "three-line": "",
      "dense": "",
      "subheader": ""
    }
  }, [(_vm.record.medical_aid) ? [_c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Medical aid details\n        "), _c('v-spacer'), _vm._v(" "), (_vm.relationshipId) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchCustomerDetailsDialog(_vm.relationshipId, true, 1)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.record.medical_aid.name || 'n/a'))]), _vm._v(" "), (_vm.record.medical_aid.scheme) ? _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_vm._v("\n            " + _vm._s(_vm.record.medical_aid.scheme) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("# " + _vm._s(_vm.record.medical_aid.number || 'no membership number'))])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "overline"
  }, [_vm._v("Patient")]), _vm._v(" "), _c('v-list-tile-title', {
    staticClass: "text--primary"
  }, [_vm._v("\n            " + _vm._s(_vm.record.medical_aid.patient_first_name) + " " + _vm._s(_vm.record.medical_aid.patient_last_name) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("ID: " + _vm._s(_vm.record.medical_aid.patient_id_number || 'unknown'))])], 1)], 1), _vm._v(" "), (_vm.record.medical_aid.is_dependent === true) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "overline"
  }, [_vm._v("Main member")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_vm._v(_vm._s(_vm.record.medical_aid.member_first_name) + " " + _vm._s(_vm.record.medical_aid.member_last_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("ID: " + _vm._s(_vm.record.medical_aid.member_id_number || 'unknown'))])], 1)], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n      Invoice information\n      "), _c('v-spacer'), _vm._v(" "), (_vm.relationshipId) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchCustomerDetailsDialog(_vm.relationshipId, true, 2)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.record.patient) ? [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Billing address")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_c('pre', {
    staticStyle: {
      "font-family": "Roboto,sans-serif"
    }
  }, [_vm._v(_vm._s(_vm.record.patient.billing_address || 'Unknown. We\'ll use contact details above') + "\n            ")])])], 1)], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-alert', {
    staticClass: "mb-0",
    attrs: {
      "type": "warning",
      "value": _vm.request.status > 299
    }
  }, [_vm._v("\n    Unable to load client record\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_vm._v("Try again")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33472b50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientCard.vue
// module id = 1383
// module chunks = 9